// The transition that plays once a login has succeeded ("Lift"): the card
// rises a little and fades while the page dims to black, then the browser
// moves on from the black frame. About 0.9 s.
//
// It runs only after the server has said yes. While the request is pending
// the login button shows a spinner (LoginApp.js), so a failed login has
// nothing to undo.

const T = {cardFade: 600, dimStart: 200, end: 850};

const clamp01 = v => Math.max(0, Math.min(1, v));
const easeOut = p => 1 - (1 - p) ** 3;
const easeInOut = p => (p < 0.5 ? 4 * p * p * p : 1 - (-2 * p + 2) ** 3 / 2);

export function prefersReducedMotion() {
	return typeof window !== 'undefined' && window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
}

export function createLoginLaunch({canvas, card}) {
	const ctx = canvas.getContext('2d');
	let raf = 0;

	const resize = () => {
		const dpr = Math.min(window.devicePixelRatio || 1, 2);
		canvas.width = window.innerWidth * dpr;
		canvas.height = window.innerHeight * dpr;
		ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
	};

	return {
		// Nothing to show until the server answers; kept so the caller's flow
		// (start, then succeed or fail) doesn't depend on which effect is in use.
		start() {},
		// The server said yes: play the lift, then call `then` from the black frame.
		succeed(then) {
			resize();
			canvas.style.display = 'block';
			const t0 = performance.now();
			const frame = now => {
				const t = now - t0;
				const p = easeOut(clamp01(t / T.cardFade));
				card.style.transform = `translateY(${-14 * p}px)`;
				card.style.opacity = String(1 - p);
				ctx.clearRect(0, 0, window.innerWidth, window.innerHeight);
				ctx.fillStyle = `rgba(0,0,0,${easeInOut(clamp01((t - T.dimStart) / (T.end - T.dimStart)))})`;
				ctx.fillRect(0, 0, window.innerWidth, window.innerHeight);
				if (t < T.end) {
					raf = requestAnimationFrame(frame);
				} else if (then) {
					then(); // leave the black frame up while the browser navigates
				}
			};
			raf = requestAnimationFrame(frame);
		},
		fail() {},
		// Back to the plain page, e.g. when the navigation never happened.
		stop() {
			cancelAnimationFrame(raf);
			ctx.clearRect(0, 0, canvas.width, canvas.height);
			canvas.style.display = 'none';
			card.style.transform = '';
			card.style.opacity = '';
		},
	};
}
